import baseClient from './baseClient';

const getRules = async () => {
    return baseClient.get('points/structure');
}

const login = async (email, password) => {
    return baseClient.post('user/login', { email, password })
}

const forgotPassword = async (email) => {
    return baseClient.patch('user/forgot-password', { email })
}

const resetPassword = async (userId, newPassword, newPasswordHash) => {
    return baseClient.post('user/reset-password', { userId, newPassword, newPasswordHash })
}

const getUser = async (userId) => {
    return baseClient.get(`user/${userId}`);
}

const updateUserDetails = async (userId, values) => {
    return baseClient.post(`user/${userId}`, values);
}

const createAccount = async ({ email, name, password, ecbOptIn}) => {

    return baseClient.post(
        'user/register',
        {
            email,
            name,
            password,
            ecbOptIn
        }
    );
}

const deleteAccount = async (userId) => {
    return baseClient.delete(`user/${userId}`);
}

const getUserMiniLeagues = async () => {
    return baseClient.get('mini-leagues');
}

const createMiniLeague = async (leagueName) => {
    return baseClient.post('mini-leagues/create', { name: leagueName });
}

const joinMiniLeague = async (leagueCode) => {
    return baseClient.post('mini-leagues/join', { joinCode: leagueCode });
}

const deleteMiniLeague = async (leagueId) => {
    return baseClient.delete(`mini-leagues/${leagueId}`);
}

export {
    getRules,
    login,
    forgotPassword,
    resetPassword,
    getUser,
    createAccount,
    updateUserDetails,
    deleteAccount,
    getUserMiniLeagues,
    createMiniLeague,
    joinMiniLeague,
    deleteMiniLeague
}
